module.exports = "/_next/static/images/46f5e716916e87b5e4f26cb32db067d7-hick@3x.png.webp";